import { generatePath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  MobileListItem,
  MobileListItemHeader,
  MobileListItemContent,
  MobileListItemField,
  MobileListItemBadge,
} from "@/components/mobile-list";
import { ReadContractorCard } from "@/types/contractorCard";
import { PATH_CONTRACTOR_CARD } from "@/constants";
import { memo, useMemo } from "react";
import { FileText, Upload } from "lucide-react";

interface CardListItemProps {
  card: ReadContractorCard;
}

export const CardListItem = memo(({ card }: CardListItemProps) => {
  const { t } = useTranslation();

  const CardStatusBadge = useMemo(
    () =>
      card.card_filename ? (
        <MobileListItemBadge variant="default">
          <FileText className="w-3 h-3 mr-1" />
          {t("contractorCards.actions.upload")}
        </MobileListItemBadge>
      ) : (
        <MobileListItemBadge variant="warning">
          <Upload className="w-3 h-3 mr-1" />
          {t("contractorCards.messages.noCard")}
        </MobileListItemBadge>
      ),
    [card.card_filename, t],
  );

  return (
    <MobileListItem
      key={card.id}
      to={generatePath(PATH_CONTRACTOR_CARD, {
        contractorCardId: card.id,
      })}
    >
      <MobileListItemHeader
        title={card.project_name}
        subtitle={card.store_name}
        badge={CardStatusBadge}
      />
      <MobileListItemContent>
        <MobileListItemField
          label={t("contractorCards.fields.period")}
          value={card.period}
        />
        <MobileListItemField
          label={t("contractorCards.fields.card")}
          value={card.card_filename}
        />
      </MobileListItemContent>
    </MobileListItem>
  );
});
